import { Link } from 'react-router-dom';
import VideoCard from '@/components/feature/VideoCard';
import { videos, categories } from '@/mocks/data';

export default function FeaturedVideos() {
  const featured = videos
    .filter((v) => v.category === 'jingxuan')
    .slice(0, 4);

  const getCategoryName = (slug: string) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? cat.name : '';
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">编辑精选，口碑佳作</p>
          </div>
          <Link
            to="/category/jingxuan"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featured.map((video) => (
            <VideoCard
              key={video.id}
              slug={video.slug}
              title={video.title}
              thumbnail={video.thumbnail}
              duration={video.duration}
              views={video.views}
              date={video.date}
              rating={video.rating}
              category={getCategoryName(video.category)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}